import {fabric} from 'fabric';

const EraserBrush = fabric.util.createClass(fabric.PencilBrush, {
  onMouseDown: function(pointer) {
    this.canvas.contextTop.globalCompositeOperation = 'destination-out';
    this._prepareForDrawing(pointer);
    // capture coordinates immediately
    // this allows to draw dots (when movement never occurs)
    this._captureDrawingPath(pointer);
    this._render();
  },

  onMouseUp: function() {
    this.oldEnd = undefined;
    this._finalizeAndAddPath();
    this.canvas.contextTop.globalCompositeOperation = 'source-over';
  },

  _finalizeAndAddPath: function() {
    let ctx = this.canvas.contextTop;
    ctx.closePath();
    let pathData = this.convertPointsToSVGPath(this._points).join('');
    if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
      // do not create 0 width/height paths, as they are
      // rendered inconsistently across browsers
      // Firefox 4, for example, renders a dot,
      // whereas Chrome 10 renders nothing
      this.canvas.requestRenderAll();
      return;
    }
    let path = this.createPath(pathData);
    this.canvas.clearContext(this.canvas.contextTop);

    // path.opacity = 0.5;
    // path.globalCompositeOperation = 'xor';
    path.globalCompositeOperation = 'destination-out';
    this.canvas.add(path);
    this.canvas.renderAll();
    path.setCoords();
    this._resetShadow();
    // fire event 'path' created
    this.canvas.fire('path:created', {path: path});
  }
});

export default EraserBrush;